import { useLocation } from "react-router-dom";
import { CardListPage } from "components/Category/Category";
import { formatNCRCategoryRow } from "./NCRCategoryList.formatters";
import { getCrudItems } from "./NCRCategoryList.crud";
import {
  rowCellOptions,
  NCR_CATEGORY_LIST_COLUMNS,
  NCR_CATEGORY_LIST_ENDPOINTS,
} from "./NCRCategoryList.config";
import { NCRCategoryRow, NCRCategoryListProps } from "./NCRCategoryList.types";

/**
 * Custom hook to generate all Category component props for NCR categories
 * @param props - NCR category list component props
 * @param location - React Router location object
 * @returns Object containing all props needed for the Category component
 */
export function useNCRCategoryCategoryProps(
  props: NCRCategoryListProps,
  location: ReturnType<typeof useLocation>
) {
  const crudItems = getCrudItems();

  return {
    location,
    noun: "NCR category",
    idColumn: NCR_CATEGORY_LIST_COLUMNS.Id,
    listEndpointUrl: NCR_CATEGORY_LIST_ENDPOINTS.list,
    defaultBActiveFilterColumnKey: NCR_CATEGORY_LIST_COLUMNS.Active,
    rowFormatter: formatNCRCategoryRow,
    hiddenColumns: [NCR_CATEGORY_LIST_COLUMNS.Id] as (keyof NCRCategoryRow)[],
    crudComponents: crudItems,
    hideHeaderTitle: true,
    defaultCardOrListView: CardListPage.List,
    largeRightPanel: false,
    hideCardPage: true,
    rowCellOptions,
  };
}
